import { functions, httpsCallable } from '../firebaseConfig';

const HALLS_BASE = 'https://halls.norewyn.academy/';

// Aabn Halls med SSO (auto-login) + valgfrit deep-link via hash (#/<path>?id=<id>).
// Vinduet aabnes SYNKRONT i klik-gesten (undgaar popup-blocker), og redirectes naar tokenet er mintet.
// 30-8-2026: samme adresse som openInHalls bygger, men som STRENG.
// Bruges af lektie-vaelgeren i GuardianBoard, hvor adressen gemmes i
// sections.homework.link og klikkes af eleven senere — der er intet vindue at
// aabne og intet token at hente paa det tidspunkt.
// Formen staar KUN her; bygger vi den ogsaa i komponenten, driver de fra hinanden
// foerste gang broen aendrer sig.
export const hallsLink = (path: string = 'dashboard', id?: string, srcKey?: string): string => {
  const qs = srcKey && id
    ? '?src=' + encodeURIComponent(srcKey) + '&id=' + encodeURIComponent(id)
    : (id ? '?id=' + encodeURIComponent(id) : '');
  return HALLS_BASE + '#/' + path + qs;
};

export const openInHalls = async (path: string = 'dashboard', id?: string, srcKey?: string): Promise<void> => {
  // 17-8-2026: srcKey bruger Halls' generelle deep-link-bro (?src=<kilde>&id=<id>),
  // som slaar jumpKey op i INJECTION_SOURCES. Uden srcKey: gammel ?id=-form.
  const qs = srcKey && id
    ? '?src=' + encodeURIComponent(srcKey) + '&id=' + encodeURIComponent(id)
    : (id ? '?id=' + encodeURIComponent(id) : '');
  const hash = '#/' + path + qs;
  const w = window.open('about:blank', '_blank');
  const go = (url: string) => { if (w) w.location.href = url; else window.open(url, '_blank', 'noopener'); };
  try {
    const res: any = await httpsCallable(functions, 'mintSsoToken')();
    const token = res?.data?.token;
    go(token ? `${HALLS_BASE}?sso=${encodeURIComponent(token)}${hash}` : `${HALLS_BASE}${hash}`);
  } catch (e) {
    console.warn('SSO mint fejlede — aabner Halls uden auto-login:', e);
    go(`${HALLS_BASE}${hash}`);
  }
};
